import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵinject, ɵɵelement, ɵɵproperty, ɵɵnextContext, ɵɵadvance, ɵɵtextInterpolate1, ɵɵdirectiveInject, ɵɵlistener, ɵɵtemplate, ɵɵsanitizeUrl, ɵɵtextInterpolate, NgZone, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { Router, RouterLinkWithHref, ActivatedRoute, RouterModule } from '@angular/router';
import { FormGroup, FormControl, Validators, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, MaxLengthValidator, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RestService, EnvironmentService, FormValidationService, loaderserice, alertserice, CDDropdownComponent, CdmulitselectComponent, ServiceCommonModule } from 'service-common';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { TranslateService, TranslateDirective, TranslateModule } from '@ngx-translate/core';
import { NgIf, CommonModule } from '@angular/common';

class ServiceAccountService {
    constructor() { }
}
ServiceAccountService.ɵfac = function ServiceAccountService_Factory(t) { return new (t || ServiceAccountService)(); };
ServiceAccountService.ɵprov = ɵɵdefineInjectable({ token: ServiceAccountService, factory: ServiceAccountService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceAccountService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ServiceAccountComponent {
    constructor() { }
    ngOnInit() {
    }
}
ServiceAccountComponent.ɵfac = function ServiceAccountComponent_Factory(t) { return new (t || ServiceAccountComponent)(); };
ServiceAccountComponent.ɵcmp = ɵɵdefineComponent({ type: ServiceAccountComponent, selectors: [["lib-service-account"]], decls: 2, vars: 0, template: function ServiceAccountComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " service-account works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceAccountComponent, [{
        type: Component,
        args: [{
                selector: 'lib-service-account',
                template: `
    <p>
      service-account works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class loginModel {
}

class loginService extends RestService {
    constructor(http, env) {
        super(http);
        this.http = http;
        this.env = env;
    }
    login(data) {
        let url = this.env.authServerUrl + '/api/Auth/login';
        let header = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        return this.http.post(url, data);
    }
    addCompany(data) {
        let url = this.env.ApiGateway + '/AddCompany';
        return super.post(url, data);
    }
    register(data) {
        let url = this.env.authServerUrl + '/api/Auth/register';
        return super.post(url, data);
    }
    ResetPassword(data) {
        let url = this.env.authServerUrl + '/api/Auth/ResetPassword';
        return super.post(url, data);
    }
    loadSellers() {
        let url = this.env.authServerUrl + '/api/Auth/GetSalesExecutive';
        return super.Get(url);
    }
    getCaptch() {
        let url = this.env.authServerUrl + '/api/Captch/Getcaptcha';
        return super.Get(url);
    }
    forgotPassword(UserName) {
        let url = this.env.authServerUrl + '/api/Auth/Forgotpassword?UserName=' + UserName;
        return super.Get(url);
    }
}
loginService.ɵfac = function loginService_Factory(t) { return new (t || loginService)(ɵɵinject(HttpClient), ɵɵinject(EnvironmentService)); };
loginService.ɵprov = ɵɵdefineInjectable({ token: loginService, factory: loginService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(loginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: EnvironmentService }]; }, null); })();

function LoginComponent_label_22_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 25);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.login.username_error");
} }
function LoginComponent_label_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 26);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r1.translate.instant(ctx_r1.formgroup.get("username").errors == null ? null : ctx_r1.formgroup.get("username").errors.serverError), " ");
} }
function LoginComponent_label_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 25);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.login.password_error");
} }
function LoginComponent_label_28_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 26);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r3.translate.instant(ctx_r3.formgroup.get("password").errors == null ? null : ctx_r3.formgroup.get("password").errors.serverError), " ");
} }
class LoginComponent {
    constructor(environment, loginservice, translate, formvalidationService, loader, router, alertservice) {
        this.environment = environment;
        this.loginservice = loginservice;
        this.translate = translate;
        this.formvalidationService = formvalidationService;
        this.loader = loader;
        this.router = router;
        this.alertservice = alertservice;
        this.submited = false;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
    }
    ngOnInit() {
        this.item = new loginModel();
        this.formgroup = new FormGroup({
            username: new FormControl('', Validators.required),
            password: new FormControl('', Validators.required)
        });
    }
    IsFieldValid(form, field) {
        return !form.get(field).valid && form.get(field).dirty;
    }
    submit() {
        if (this.formgroup.valid) {
            this.loader.show(true);
            let formdata = new FormData();
            formdata.append('client_id', this.environment.clientId);
            formdata.append('client_secret', this.environment.ClientSecret);
            formdata.append('grant_type', this.environment.GrantType);
            formdata.append('username', this.item.username);
            formdata.append('password', this.item.password);
            formdata.append('scope', this.environment.Scope);
            this.loginservice.login(formdata).subscribe(result => {
                this.loader.show(false);
                localStorage.clear();
                this.environment.Authtoken = result.accessToken;
                if (result == null) {
                    this.environment.GetModuleAcccess();
                    this.alertservice.Error('', this.translate.instant('auth.login.invalidPassword'));
                    return;
                }
                if ((this.environment.returnUrl != '' && this.environment.returnUrl != undefined && this.environment.returnUrl != null) && this.environment.IsAdminLogin) {
                    this.environment.GetModuleAcccess();
                    return this.router.navigateByUrl(this.environment.returnUrl);
                }
                else if (this.environment.IsAdminLogin) {
                    this.environment.GetModuleAcccess();
                    return this.router.navigateByUrl('/admin');
                }
                if (this.environment.returnUrl == '' || this.environment.returnUrl == undefined || this.environment.returnUrl == null) {
                    this.environment.GetModuleAcccess();
                    return this.router.navigateByUrl('/inventory');
                }
                else {
                    return this.router.navigateByUrl(this.environment.returnUrl);
                }
            }, reject => {
                this.loader.show(false);
                try {
                    this.formvalidationService.BindServerErrors(this.formgroup, reject);
                }
                catch (error) {
                    console.log(error);
                }
            });
        }
    }
    forgotPassword() {
        if (this.item.username == '' || this.item.username == undefined) {
            this.submited = true;
            return;
        }
        this.loader.show(true);
        this.loginservice.forgotPassword(this.item.username).subscribe(result => {
            this.loader.show(false);
            if (result == null) {
                this.alertservice.Error('', this.translate.instant('auth.login.errorMessage'));
            }
            else if (result.status) {
                this.alertservice.success('', this.translate.instant(result.message));
            }
            else {
                this.alertservice.Error('', this.translate.instant(result.message));
            }
        }, reject => {
            this.loader.show(false);
            this.alertservice.Error('', this.translate.instant('auth.login.errorMessage'));
        });
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵɵdirectiveInject(EnvironmentService), ɵɵdirectiveInject(loginService), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(FormValidationService), ɵɵdirectiveInject(loaderserice), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(alertserice)); };
LoginComponent.ɵcmp = ɵɵdefineComponent({ type: LoginComponent, selectors: [["lib-login"]], decls: 43, vars: 17, consts: [[1, "overlay"], [1, "signin", "d-flex"], [1, "container"], [1, "row"], [1, "col"], [1, "d-flex", "justify-content-between", "signin-header", "align-items-center"], [1, "logo"], ["href", "#"], ["alt", "", "width", "143px", 1, "img-fluid", 2, "width", "143px", 3, "src"], ["href", "/home", 1, "login-btn"], [1, "signin-form", 3, "formGroup", "ngSubmit"], [3, "translate"], [1, "form-group", "m-0"], ["for", "username m-0", 3, "translate"], ["formControlName", "username", "name", "username", "type", "text", "id", "username", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["class", "form-text text-danger", 3, "translate", 4, "ngIf"], ["class", "form-text text-danger", 4, "ngIf"], ["for", "password m-0", 3, "translate"], ["formControlName", "password", "name", "password", "type", "password", "id", "password", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-text", "text-white", "text-right", "fogpass", 3, "translate", "click"], [1, "d-flex", "justify-content-between", "signin-btn"], ["href", "/guest", "type", "button", 3, "translate"], ["type", "submit", 1, "signin-btn", 3, "translate"], [1, "row", "noaccount"], ["routerLink", "/auth/register", 3, "translate"], [1, "form-text", "text-danger", 3, "translate"], [1, "form-text", "text-danger"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "section", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelementStart(6, "div", 6);
        ɵɵelementStart(7, "a", 7);
        ɵɵelement(8, "img", 8);
        ɵɵelementStart(9, "p");
        ɵɵelementStart(10, "small");
        ɵɵtext(11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "a", 9);
        ɵɵtext(13, "Visit Website");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 3);
        ɵɵelementStart(15, "div", 4);
        ɵɵelementStart(16, "form", 10);
        ɵɵlistener("ngSubmit", function LoginComponent_Template_form_ngSubmit_16_listener() { return ctx.submit(); });
        ɵɵelementStart(17, "h4", 11);
        ɵɵtext(18, "SIGN IN");
        ɵɵelementEnd();
        ɵɵelementStart(19, "div", 12);
        ɵɵelement(20, "label", 13);
        ɵɵelementStart(21, "input", 14);
        ɵɵlistener("ngModelChange", function LoginComponent_Template_input_ngModelChange_21_listener($event) { return ctx.item.username = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(22, LoginComponent_label_22_Template, 1, 1, "label", 15);
        ɵɵtemplate(23, LoginComponent_label_23_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(24, "div", 12);
        ɵɵelement(25, "label", 17);
        ɵɵelementStart(26, "input", 18);
        ɵɵlistener("ngModelChange", function LoginComponent_Template_input_ngModelChange_26_listener($event) { return ctx.item.password = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(27, LoginComponent_label_27_Template, 1, 1, "label", 15);
        ɵɵtemplate(28, LoginComponent_label_28_Template, 2, 1, "label", 16);
        ɵɵelementStart(29, "a", 19);
        ɵɵlistener("click", function LoginComponent_Template_a_click_29_listener() { return ctx.forgotPassword(); });
        ɵɵtext(30, "Forgot Password");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(31, "div", 20);
        ɵɵelementStart(32, "a", 21);
        ɵɵtext(33, "Guest");
        ɵɵelementEnd();
        ɵɵelementStart(34, "button", 22);
        ɵɵtext(35, "Sign IN");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(36, "div", 23);
        ɵɵelementStart(37, "div", 4);
        ɵɵelementStart(38, "span", 11);
        ɵɵtext(39, "Don't have an account ?");
        ɵɵelementEnd();
        ɵɵelementStart(40, "span");
        ɵɵelementStart(41, "a", 24);
        ɵɵtext(42, "Register Now");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(8);
        ɵɵproperty("src", ctx.AppLogo, ɵɵsanitizeUrl);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.AppTitle);
        ɵɵadvance(5);
        ɵɵproperty("formGroup", ctx.formgroup);
        ɵɵadvance(1);
        ɵɵproperty("translate", "auth.login.title");
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.login.email");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.username);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("username").errors == null ? null : ctx.formgroup.get("username").errors.required) && (ctx.formgroup.get("username").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("username").errors == null ? null : ctx.formgroup.get("username").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "auth.login.password");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.password);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.required) && ctx.formgroup.get("password").touched);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.serverError);
        ɵɵadvance(1);
        ɵɵproperty("translate", "auth.login.forgotpassword");
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.login.guest");
        ɵɵadvance(2);
        ɵɵproperty("translate", "auth.login.signin");
        ɵɵadvance(4);
        ɵɵproperty("translate", "auth.login.donthaveaccount");
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.login.registernow");
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, TranslateDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgIf, RouterLinkWithHref], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'lib-login',
                templateUrl: './login.component.html',
                styleUrls: ['./login.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }, { type: loginService }, { type: TranslateService }, { type: FormValidationService }, { type: loaderserice }, { type: Router }, { type: alertserice }]; }, null); })();

class UserAccountInfoModel {
}

class UserAddressInfoModel {
}

class UserBasicInfoModel {
}

class UserModel {
    constructor() {
        this.userName = '';
        this.password = '';
        this.confirmPassword = '';
        this.sellerId = '';
        this.captchCode = '';
        this.userBasicInfo = new UserBasicInfoModel();
        this.userAddressInfo = new UserAddressInfoModel();
        this.userAccountInfo = new UserAccountInfoModel();
        this.userReferralInfo = [];
    }
}

class UserReferralInfo {
}

function RegisterComponent_label_31_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.username_error");
} }
function RegisterComponent_label_32_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r1.translate.instant(ctx_r1.formgroup.get("userName").errors == null ? null : ctx_r1.formgroup.get("userName").errors.serverError), " ");
} }
function RegisterComponent_label_37_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.password_error");
} }
function RegisterComponent_label_38_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r3.translate.instant(ctx_r3.formgroup.get("password").errors == null ? null : ctx_r3.formgroup.get("password").errors.serverError), " ");
} }
function RegisterComponent_label_43_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.confirmPassword_error");
} }
function RegisterComponent_label_44_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.confirmPassword_matche_error");
} }
function RegisterComponent_label_45_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r6.translate.instant(ctx_r6.formgroup.get("confirmPassword").errors == null ? null : ctx_r6.formgroup.get("confirmPassword").errors.serverError), " ");
} }
function RegisterComponent_label_50_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.companyId_error");
} }
function RegisterComponent_label_51_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r8.translate.instant(ctx_r8.formgroup.get("companyId").errors == null ? null : ctx_r8.formgroup.get("companyId").errors.serverError), " ");
} }
function RegisterComponent_label_56_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.firstName_error");
} }
function RegisterComponent_label_57_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r10.translate.instant(ctx_r10.formgroup.get("firstName").errors == null ? null : ctx_r10.formgroup.get("firstName").errors.serverError), " ");
} }
function RegisterComponent_label_62_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.lastName_error");
} }
function RegisterComponent_label_63_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r12.translate.instant(ctx_r12.formgroup.get("lastName").errors == null ? null : ctx_r12.formgroup.get("lastName").errors.serverError), " ");
} }
function RegisterComponent_label_68_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.emailId_error");
} }
function RegisterComponent_label_69_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.emailId_error");
} }
function RegisterComponent_label_70_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r15.translate.instant(ctx_r15.formgroup.get("emailId").errors == null ? null : ctx_r15.formgroup.get("emailId").errors.serverError), " ");
} }
function RegisterComponent_label_75_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.cCEmailId_error");
} }
function RegisterComponent_label_76_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.cCEmailId_error");
} }
function RegisterComponent_label_77_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r18.translate.instant(ctx_r18.formgroup.get("cCEmailId").errors == null ? null : ctx_r18.formgroup.get("cCEmailId").errors.serverError), " ");
} }
function RegisterComponent_label_82_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.contactNo_error");
} }
function RegisterComponent_label_83_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r20.translate.instant(ctx_r20.formgroup.get("contactNo").errors == null ? null : ctx_r20.formgroup.get("contactNo").errors.serverError), " ");
} }
function RegisterComponent_label_88_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.faxNo_error");
} }
function RegisterComponent_label_89_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r22.translate.instant(ctx_r22.formgroup.get("faxNo").errors == null ? null : ctx_r22.formgroup.get("faxNo").errors.serverError), " ");
} }
function RegisterComponent_label_94_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.whatsAppNo_error");
} }
function RegisterComponent_label_95_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r24.translate.instant(ctx_r24.formgroup.get("whatsAppNo").errors == null ? null : ctx_r24.formgroup.get("whatsAppNo").errors.serverError), " ");
} }
function RegisterComponent_label_100_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.skypeId_error");
} }
function RegisterComponent_label_101_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r26.translate.instant(ctx_r26.formgroup.get("skypeId").errors == null ? null : ctx_r26.formgroup.get("skypeId").errors.serverError), " ");
} }
function RegisterComponent_label_106_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.qQId_error");
} }
function RegisterComponent_label_107_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r28.translate.instant(ctx_r28.formgroup.get("qQId").errors == null ? null : ctx_r28.formgroup.get("qQId").errors.serverError), " ");
} }
function RegisterComponent_label_112_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.website_error");
} }
function RegisterComponent_label_113_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r30.translate.instant(ctx_r30.formgroup.get("website").errors == null ? null : ctx_r30.formgroup.get("website").errors.serverError), " ");
} }
function RegisterComponent_label_122_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.billingAddress_error");
} }
function RegisterComponent_label_123_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r32.translate.instant(ctx_r32.formgroup.get("billingAddress").errors == null ? null : ctx_r32.formgroup.get("billingAddress").errors.serverError), " ");
} }
function RegisterComponent_label_128_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.billingCountryId_error");
} }
function RegisterComponent_label_129_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r34.translate.instant(ctx_r34.formgroup.get("billingCountryId").errors == null ? null : ctx_r34.formgroup.get("billingCountryId").errors.serverError), " ");
} }
function RegisterComponent_label_134_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.billingStateId_error");
} }
function RegisterComponent_label_135_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r36.translate.instant(ctx_r36.formgroup.get("billingStateId").errors == null ? null : ctx_r36.formgroup.get("billingStateId").errors.serverError), " ");
} }
function RegisterComponent_label_140_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.billingCityId_error");
} }
function RegisterComponent_label_141_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r38.translate.instant(ctx_r38.formgroup.get("billingCityId").errors == null ? null : ctx_r38.formgroup.get("billingCityId").errors.serverError), " ");
} }
function RegisterComponent_label_146_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.billingZipCode_error");
} }
function RegisterComponent_label_147_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r40.translate.instant(ctx_r40.formgroup.get("billingZipCode").errors == null ? null : ctx_r40.formgroup.get("billingZipCode").errors.serverError), " ");
} }
function RegisterComponent_label_156_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.shippingAddress_error");
} }
function RegisterComponent_label_157_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r42.translate.instant(ctx_r42.formgroup.get("shippingAddress").errors == null ? null : ctx_r42.formgroup.get("shippingAddress").errors.serverError), " ");
} }
function RegisterComponent_label_162_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.shippingCountryId_error");
} }
function RegisterComponent_label_163_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r44.translate.instant(ctx_r44.formgroup.get("shippingCountryId").errors == null ? null : ctx_r44.formgroup.get("shippingCountryId").errors.serverError), " ");
} }
function RegisterComponent_label_168_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.shippingStateId_error");
} }
function RegisterComponent_label_169_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r46.translate.instant(ctx_r46.formgroup.get("shippingStateId").errors == null ? null : ctx_r46.formgroup.get("shippingStateId").errors.serverError), " ");
} }
function RegisterComponent_label_174_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.shippingCityId_error");
} }
function RegisterComponent_label_175_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r48.translate.instant(ctx_r48.formgroup.get("shippingCityId").errors == null ? null : ctx_r48.formgroup.get("shippingCityId").errors.serverError), " ");
} }
function RegisterComponent_label_180_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.shippingZipCode_error");
} }
function RegisterComponent_label_181_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r50.translate.instant(ctx_r50.formgroup.get("shippingZipCode").errors == null ? null : ctx_r50.formgroup.get("shippingZipCode").errors.serverError), " ");
} }
function RegisterComponent_label_190_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.gstNo_error");
} }
function RegisterComponent_label_191_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r52.translate.instant(ctx_r52.formgroup.get("gstNo").errors == null ? null : ctx_r52.formgroup.get("gstNo").errors.serverError), " ");
} }
function RegisterComponent_label_196_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.coBuyerName_error");
} }
function RegisterComponent_label_197_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r54.translate.instant(ctx_r54.formgroup.get("coBuyerName").errors == null ? null : ctx_r54.formgroup.get("coBuyerName").errors.serverError), " ");
} }
function RegisterComponent_label_202_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.sellerId_error");
} }
function RegisterComponent_label_203_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r56 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r56.translate.instant(ctx_r56.formgroup.get("sellerId").errors == null ? null : ctx_r56.formgroup.get("sellerId").errors.serverError), " ");
} }
function RegisterComponent_label_212_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r57 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r57.translate.instant(ctx_r57.formgroup.get("refName1").errors == null ? null : ctx_r57.formgroup.get("refName1").errors.serverError), " ");
} }
function RegisterComponent_label_216_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.refCompany_error");
} }
function RegisterComponent_label_217_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r59.translate.instant(ctx_r59.formgroup.get("refcompanyName1").errors == null ? null : ctx_r59.formgroup.get("refcompanyName1").errors.serverError), " ");
} }
function RegisterComponent_label_222_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.refcontactNo_error");
} }
function RegisterComponent_label_223_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r61.translate.instant(ctx_r61.formgroup.get("refcontactNo1").errors == null ? null : ctx_r61.formgroup.get("refcontactNo1").errors.serverError), " ");
} }
function RegisterComponent_label_228_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r62.translate.instant(ctx_r62.formgroup.get("refName2").errors == null ? null : ctx_r62.formgroup.get("refName2").errors.serverError), " ");
} }
function RegisterComponent_label_233_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.refCompany_error");
} }
function RegisterComponent_label_234_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r64.translate.instant(ctx_r64.formgroup.get("refcompanyName2").errors == null ? null : ctx_r64.formgroup.get("refcompanyName2").errors.serverError), " ");
} }
function RegisterComponent_label_239_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.refcontactNo_error");
} }
function RegisterComponent_label_240_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r66.translate.instant(ctx_r66.formgroup.get("refcontactNo2").errors == null ? null : ctx_r66.formgroup.get("refcontactNo2").errors.serverError), " ");
} }
function RegisterComponent_label_252_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 99);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.register.captchCode_error");
} }
function RegisterComponent_label_253_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 100);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r68.translate.instant(ctx_r68.formgroup.get("captchCode").errors == null ? null : ctx_r68.formgroup.get("captchCode").errors.serverError), " ");
} }
class RegisterComponent {
    constructor(environment, translate, formvalidationService, loader, router, loginService, alertService, ngzone) {
        this.environment = environment;
        this.translate = translate;
        this.formvalidationService = formvalidationService;
        this.loader = loader;
        this.router = router;
        this.loginService = loginService;
        this.alertService = alertService;
        this.ngzone = ngzone;
        this.shippingStateParam = 'GetStates';
        this.submited = false;
        this.Language = translate.currentLang;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
    }
    ngOnInit() {
        $("body").css("overflow", "hidden");
        this.refreshCaptch();
        this.item = new UserModel();
        this.item.userReferralInfo.push(new UserReferralInfo());
        this.item.userReferralInfo.push(new UserReferralInfo());
        this.formgroup = new FormGroup({
            userName: new FormControl('', Validators.required),
            password: new FormControl('', Validators.required),
            confirmPassword: new FormControl('', Validators.required),
            companyId: new FormControl('', Validators.required),
            firstName: new FormControl('', Validators.required),
            lastName: new FormControl('', Validators.required),
            emailId: new FormControl('', Validators.compose([Validators.required, Validators.email])),
            cCEmailId: new FormControl('', Validators.compose([Validators.email])),
            contactNo: new FormControl('', Validators.required),
            faxNo: new FormControl(''),
            whatsAppNo: new FormControl(''),
            skypeId: new FormControl(''),
            qQId: new FormControl(''),
            billingAddress: new FormControl('', Validators.required),
            billingCountryId: new FormControl('', Validators.required),
            billingStateId: new FormControl('', Validators.required),
            billingCityId: new FormControl(''),
            billingZipCode: new FormControl('', Validators.required),
            shippingAddress: new FormControl('', Validators.required),
            shippingCountryId: new FormControl('', Validators.required),
            shippingStateId: new FormControl('', Validators.required),
            shippingCityId: new FormControl(''),
            shippingZipCode: new FormControl('', Validators.required),
            gstNo: new FormControl(''),
            coBuyerName: new FormControl(''),
            website: new FormControl('', Validators.required),
            refName1: new FormControl(''),
            refcompanyName1: new FormControl(''),
            refcontactNo1: new FormControl(''),
            refName2: new FormControl(''),
            refcompanyName2: new FormControl(''),
            refcontactNo2: new FormControl(''),
            sellerId: new FormControl('', Validators.required),
            captchCode: new FormControl('', Validators.required)
        });
        this.loader.show(true);
        this.loginService.loadSellers().subscribe(result => {
            this.loader.show(false);
            this.sellerList = result;
        }, error => {
            console.error(error);
            this.loader.show(false);
        });
    }
    companyChange(data) {
        this.item.userBasicInfo.companyId = data.id;
        this.companyName = data.value;
    }
    billingCountryChange(data) {
        this.item.userAddressInfo.billingCountryId = data.id;
        this.billingCounry = data.value;
        this.billingStateParam = '&id=' + this.item.userAddressInfo.billingCountryId;
    }
    billingStateChange(data) {
        this.item.userAddressInfo.billingStateId = data.id;
        this.billingCityParam = '&id=' + this.item.userAddressInfo.billingStateId;
    }
    billingCityChange(data) {
        this.item.userAddressInfo.billingCityId = data.id;
    }
    shippingCountryChange(data) {
        this.item.userAddressInfo.shippingCountryId = data.id;
        this.shippingCounry = data.value;
        this.shippingStateParam = '&id=' + this.item.userAddressInfo.shippingCountryId;
    }
    shippingStateChange(data) {
        this.item.userAddressInfo.shippingStateId = data.id;
        this.shippingCityParam = '&id=' + this.item.userAddressInfo.shippingStateId;
    }
    shippingCityChange(data) {
        this.item.userAddressInfo.shippingCityId = data.id;
    }
    sellerChange(data) {
        this.item.sellerId = data.id;
    }
    refreshCaptch() {
        this.loginService.getCaptch().subscribe(result => {
            this.captchaImg = result.imgpath;
        });
    }
    submit() {
        this.submited = true;
        if (this.formgroup.valid) {
            this.loader.show(true);
            if (this.item.userBasicInfo.companyId == null || this.item.userBasicInfo.companyId == undefined) {
                let objcompany = {
                    CompanyName: this.companyName
                };
                this.loginService.addCompany(objcompany).subscribe(result => {
                    this.item.userBasicInfo.companyId = result.companyId;
                    this.registerUser();
                }, error => {
                    this.loader.show(false);
                });
            }
            else {
                this.registerUser();
            }
        }
    }
    registerUser() {
        this.loginService.register(this.item).subscribe(result => {
            this.loader.show(false);
            if (result.status) {
                this.alertService.success('', this.translate.instant(result.message));
                this.router.navigateByUrl('/auth/login');
            }
            else {
                this.alertService.Error('', this.translate.instant(result.message));
            }
        }, reject => {
            this.loader.show(false);
            this.alertService.Error('', this.translate.instant('auth.register.errorMessage'));
            try {
                this.formvalidationService.BindServerErrors(this.formgroup, reject);
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    LangChange(lang) {
        this.translate.use(lang);
        this.Language = lang;
    }
}
RegisterComponent.ɵfac = function RegisterComponent_Factory(t) { return new (t || RegisterComponent)(ɵɵdirectiveInject(EnvironmentService), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(FormValidationService), ɵɵdirectiveInject(loaderserice), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(loginService), ɵɵdirectiveInject(alertserice), ɵɵdirectiveInject(NgZone)); };
RegisterComponent.ɵcmp = ɵɵdefineComponent({ type: RegisterComponent, selectors: [["lib-register"]], decls: 275, vars: 199, consts: [[1, "row", 2, "margin-left", "0px !important", "margin-right", "0px !important"], [1, "col-sm-4", 2, "padding-right", "0px"], ["autocomplete", "off", 2, "padding-left", "5px !important", "padding-right", "5px !important", 3, "formGroup", "ngSubmit"], [1, "row", "mt-2"], [1, "col-sm-3"], [1, "pull-left"], ["type", "submit", 1, "btn", "btn-primary", 3, "translate"], [1, "col-sm-6"], [2, "text-align", "center", 3, "translate"], [1, "pull-right"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn", "btn-primary", "dropdown-toggle"], [1, "dropdown-menu"], ["href", "#", 1, "dropdown-item", 3, "click"], [1, "dropdown-item"], [2, "overflow", "auto", "height", "88vh", "overflow-x", "hidden"], [3, "translate"], [1, "row"], [1, "col-sm-12"], [1, "form-group"], ["for", "userName ", 3, "translate"], ["maxlength", "50", "formControlName", "userName", "name", "userName", "type", "text", "id", "userName", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["class", "form-text text-danger", 3, "translate", 4, "ngIf"], ["class", "form-text text-danger", 4, "ngIf"], ["for", "password ", 3, "translate"], ["maxlength", "50", "formControlName", "password", "name", "password", "type", "password", "id", "password", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "confirmPassword ", 3, "translate"], ["maxlength", "50", "formControlName", "confirmPassword", "name", "confirmPassword", "type", "password", "id", "confirmPassword", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "companyId ", 3, "translate"], [3, "form", "modelkey", "modelvalue", "formcontrolname", "path", "valuemember", "displaymember", "modelkeyChange", "modelvalueChange", "change"], ["for", "firstName ", 3, "translate"], ["maxlength", "50", "formControlName", "firstName", "name", "firstName", "type", "text", "id", "firstName", "placeholder", "First Name", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["maxlength", "50", "formControlName", "lastName", "name", "lastName", "type", "text", "id", "lastName", "placeholder", "Last Name", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "emailId ", 3, "translate"], ["maxlength", "50", "formControlName", "emailId", "name", "emailId", "type", "text", "id", "emailId", "placeholder", "Email Id", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "cCEmailId ", 3, "translate"], ["maxlength", "50", "formControlName", "cCEmailId", "name", "cCEmailId", "type", "text", "id", "cCEmailId", "placeholder", "CCEmail Id", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "contactNo ", 3, "translate"], ["maxlength", "50", "formControlName", "contactNo", "name", "contactNo", "type", "text", "id", "contactNo", "placeholder", "ContactNo", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "faxNo ", 3, "translate"], ["formControlName", "faxNo", "name", "faxNo", "type", "text", "id", "contactNo", "placeholder", "faxNo", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "whatsAppNo ", 3, "translate"], ["maxlength", "50", "formControlName", "whatsAppNo", "name", "whatsAppNo", "type", "text", "id", "whatsAppNo", "placeholder", "WhatsAppNo", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "skypeId ", 3, "translate"], ["maxlength", "50", "formControlName", "skypeId", "name", "skypeId", "type", "text", "id", "skypeId", "placeholder", "Skype Id", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "qQId ", 3, "translate"], ["maxlength", "50", "formControlName", "qQId", "name", "qQId", "type", "text", "id", "qQId", "placeholder", "QQ Id", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "website ", 3, "translate"], ["maxlength", "50", "formControlName", "website", "name", "website", "type", "text", "id", "website", "placeholder", "website", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "billingAddress ", 3, "translate"], ["maxlength", "200", "formControlName", "billingAddress", "name", "billingAddress", "type", "text", "id", "billingAddress", "placeholder", "Address", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "modelkey", "modelvalue", "form", "formcontrolname", "path", "valuemember", "displaymember", "modelkeyChange", "modelvalueChange", "change"], ["for", "billingStateId ", 3, "translate"], [3, "params", "modelkey", "form", "formcontrolname", "path", "valuemember", "displaymember", "modelkeyChange", "change"], ["for", "billingCityId ", 3, "translate"], ["for", "billingZipCode ", 3, "translate"], ["maxlength", "20", "formControlName", "billingZipCode", "name", "billingZipCode", "type", "text", "id", "billingZipCode", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "shippingAddress ", 3, "translate"], ["maxlength", "200", "formControlName", "shippingAddress", "name", "shippingAddress", "type", "text", "id", "shippingAddress", "placeholder", "Address", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "shippingStateId ", 3, "translate"], ["for", "shippingCityId ", 3, "translate"], ["for", "shippingZipCode ", 3, "translate"], ["maxlength", "20", "formControlName", "shippingZipCode", "name", "shippingZipCode", "type", "text", "id", "shippingZipCode", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "gstNo ", 3, "translate"], ["maxlength", "15", "formControlName", "gstNo", "name", "gstNo", "type", "text", "id", "gstNo", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "coBuyerName ", 3, "translate"], ["maxlength", "50", "formControlName", "coBuyerName", "name", "coBuyerName", "type", "text", "id", "coBuyerName", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "sellerId", 3, "translate"], [3, "modelkey", "datasource", "form", "formcontrolname", "valuemember", "displaymember", "change"], ["for", "refName1", 3, "translate"], ["maxlength", "20", "formControlName", "refName1", "name", "refName1", "type", "text", "id", "refName1", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "refcompanyName1", 3, "translate"], ["maxlength", "20", "formControlName", "refcompanyName1", "name", "refcompanyName1", "type", "text", "id", "refcompanyName1", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "-form-group"], ["for", "refcontactNo1", 3, "translate"], ["maxlength", "20", "formControlName", "refcontactNo1", "name", "refcontactNo1", "type", "text", "id", "refcontactNo1", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "refName2", 3, "translate"], ["maxlength", "20", "formControlName", "refName2", "name", "refName2", "type", "text", "id", "refName2", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "refcompanyName2", 3, "translate"], ["maxlength", "20", "formControlName", "refcompanyName2", "name", "refcompanyName2", "type", "text", "id", "refcompanyName2", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "refcontactNo2", 3, "translate"], ["maxlength", "20", "formControlName", "refcontactNo2", "name", "refcontactNo2", "type", "text", "id", "refcontactNo2", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "captchCode m-0", 3, "translate"], [2, "margin-left", "5px", 3, "src"], [1, "input-group"], [1, "input-group-prepend"], ["type", "button", "id", "button-addon1", "wfd-id", "1448", 1, "btn", "btn-outline-secondary", 3, "click"], ["formControlName", "captchCode", "name", "captchCode", "type", "text", "id", "captchCode", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "col-sm-8"], [1, "landing-main"], [1, "landing-main", "d-flex", "align-items-center"], [1, "row", "mx-auto"], [1, "col"], ["data-wow-duration", "4s", "data-wow-delay", "300ms", 1, "login-images", "wow", "zoomIn"], ["alt", "login-logo", "width", "420px", 1, "img-fluid", "mx-auto", "d-block", 3, "src"], [1, "company-name"], ["data-wow-duration", "4s", "data-wow-delay", "300ms", 1, "tagline", "text-white", "wow", "zoomIn"], ["data-wow-duration", "4s", "data-wow-delay", "300ms", 1, "d-flex", "justify-content-between", "landing-btn", "wow", "zoomIn"], ["href", "/home", "type", "button", 3, "translate"], ["href", "/auth/login", "type", "button", 3, "translate"], [1, "form-text", "text-danger", 3, "translate"], [1, "form-text", "text-danger"]], template: function RegisterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "form", 2);
        ɵɵlistener("ngSubmit", function RegisterComponent_Template_form_ngSubmit_2_listener() { return ctx.submit(); });
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelementStart(6, "button", 6);
        ɵɵtext(7, "Sign IN");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 7);
        ɵɵelementStart(9, "h4", 8);
        ɵɵtext(10, "SIGN IN");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(11, "div", 4);
        ɵɵelementStart(12, "div", 9);
        ɵɵelementStart(13, "button", 10);
        ɵɵtext(14);
        ɵɵelementEnd();
        ɵɵelementStart(15, "div", 11);
        ɵɵelementStart(16, "a", 12);
        ɵɵlistener("click", function RegisterComponent_Template_a_click_16_listener() { return ctx.LangChange("en"); });
        ɵɵelementStart(17, "span", 13);
        ɵɵtext(18, "EN");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(19, "a", 12);
        ɵɵlistener("click", function RegisterComponent_Template_a_click_19_listener() { return ctx.LangChange("zh"); });
        ɵɵelementStart(20, "span", 13);
        ɵɵtext(21, "ZH");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(22, "hr");
        ɵɵelementStart(23, "div", 14);
        ɵɵelementStart(24, "h5", 15);
        ɵɵtext(25, " Basic Inf");
        ɵɵelementEnd();
        ɵɵelementStart(26, "div", 16);
        ɵɵelementStart(27, "div", 17);
        ɵɵelementStart(28, "div", 18);
        ɵɵelement(29, "label", 19);
        ɵɵelementStart(30, "input", 20);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_30_listener($event) { return ctx.item.userName = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(31, RegisterComponent_label_31_Template, 1, 1, "label", 21);
        ɵɵtemplate(32, RegisterComponent_label_32_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(33, "div", 7);
        ɵɵelementStart(34, "div", 18);
        ɵɵelement(35, "label", 23);
        ɵɵelementStart(36, "input", 24);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_36_listener($event) { return ctx.item.password = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(37, RegisterComponent_label_37_Template, 1, 1, "label", 21);
        ɵɵtemplate(38, RegisterComponent_label_38_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(39, "div", 7);
        ɵɵelementStart(40, "div", 18);
        ɵɵelement(41, "label", 25);
        ɵɵelementStart(42, "input", 26);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_42_listener($event) { return ctx.item.confirmPassword = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(43, RegisterComponent_label_43_Template, 1, 1, "label", 21);
        ɵɵtemplate(44, RegisterComponent_label_44_Template, 1, 1, "label", 21);
        ɵɵtemplate(45, RegisterComponent_label_45_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(46, "div", 7);
        ɵɵelementStart(47, "div", 18);
        ɵɵelement(48, "label", 27);
        ɵɵelementStart(49, "lib-cddropdown", 28);
        ɵɵlistener("modelkeyChange", function RegisterComponent_Template_lib_cddropdown_modelkeyChange_49_listener($event) { return ctx.item.userBasicInfo.companyId = $event; })("modelvalueChange", function RegisterComponent_Template_lib_cddropdown_modelvalueChange_49_listener($event) { return ctx.companyName = $event; })("change", function RegisterComponent_Template_lib_cddropdown_change_49_listener($event) { return ctx.companyChange($event); });
        ɵɵelementEnd();
        ɵɵtemplate(50, RegisterComponent_label_50_Template, 1, 1, "label", 21);
        ɵɵtemplate(51, RegisterComponent_label_51_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(52, "div", 7);
        ɵɵelementStart(53, "div", 18);
        ɵɵelement(54, "label", 29);
        ɵɵelementStart(55, "input", 30);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_55_listener($event) { return ctx.item.userBasicInfo.firstName = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(56, RegisterComponent_label_56_Template, 1, 1, "label", 21);
        ɵɵtemplate(57, RegisterComponent_label_57_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(58, "div", 7);
        ɵɵelementStart(59, "div", 18);
        ɵɵelement(60, "label", 29);
        ɵɵelementStart(61, "input", 31);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_61_listener($event) { return ctx.item.userBasicInfo.lastName = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(62, RegisterComponent_label_62_Template, 1, 1, "label", 21);
        ɵɵtemplate(63, RegisterComponent_label_63_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(64, "div", 7);
        ɵɵelementStart(65, "div", 18);
        ɵɵelement(66, "label", 32);
        ɵɵelementStart(67, "input", 33);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_67_listener($event) { return ctx.item.userBasicInfo.emailId = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(68, RegisterComponent_label_68_Template, 1, 1, "label", 21);
        ɵɵtemplate(69, RegisterComponent_label_69_Template, 1, 1, "label", 21);
        ɵɵtemplate(70, RegisterComponent_label_70_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(71, "div", 7);
        ɵɵelementStart(72, "div", 18);
        ɵɵelement(73, "label", 34);
        ɵɵelementStart(74, "input", 35);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_74_listener($event) { return ctx.item.userBasicInfo.cCEmailId = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(75, RegisterComponent_label_75_Template, 1, 1, "label", 21);
        ɵɵtemplate(76, RegisterComponent_label_76_Template, 1, 1, "label", 21);
        ɵɵtemplate(77, RegisterComponent_label_77_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(78, "div", 7);
        ɵɵelementStart(79, "div", 18);
        ɵɵelement(80, "label", 36);
        ɵɵelementStart(81, "input", 37);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_81_listener($event) { return ctx.item.userBasicInfo.contactNo = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(82, RegisterComponent_label_82_Template, 1, 1, "label", 21);
        ɵɵtemplate(83, RegisterComponent_label_83_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(84, "div", 7);
        ɵɵelementStart(85, "div", 18);
        ɵɵelement(86, "label", 38);
        ɵɵelementStart(87, "input", 39);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_87_listener($event) { return ctx.item.userBasicInfo.faxNo = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(88, RegisterComponent_label_88_Template, 1, 1, "label", 21);
        ɵɵtemplate(89, RegisterComponent_label_89_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(90, "div", 7);
        ɵɵelementStart(91, "div", 18);
        ɵɵelement(92, "label", 40);
        ɵɵelementStart(93, "input", 41);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_93_listener($event) { return ctx.item.userBasicInfo.whatsAppNo = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(94, RegisterComponent_label_94_Template, 1, 1, "label", 21);
        ɵɵtemplate(95, RegisterComponent_label_95_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(96, "div", 7);
        ɵɵelementStart(97, "div", 18);
        ɵɵelement(98, "label", 42);
        ɵɵelementStart(99, "input", 43);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_99_listener($event) { return ctx.item.userBasicInfo.skypeId = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(100, RegisterComponent_label_100_Template, 1, 1, "label", 21);
        ɵɵtemplate(101, RegisterComponent_label_101_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(102, "div", 7);
        ɵɵelementStart(103, "div", 18);
        ɵɵelement(104, "label", 44);
        ɵɵelementStart(105, "input", 45);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_105_listener($event) { return ctx.item.userBasicInfo.qQId = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(106, RegisterComponent_label_106_Template, 1, 1, "label", 21);
        ɵɵtemplate(107, RegisterComponent_label_107_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(108, "div", 7);
        ɵɵelementStart(109, "div", 18);
        ɵɵelement(110, "label", 46);
        ɵɵelementStart(111, "input", 47);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_111_listener($event) { return ctx.item.userBasicInfo.website = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(112, RegisterComponent_label_112_Template, 1, 1, "label", 21);
        ɵɵtemplate(113, RegisterComponent_label_113_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(114, "hr");
        ɵɵelementStart(115, "h5");
        ɵɵelement(116, "span", 15);
        ɵɵelementEnd();
        ɵɵelementStart(117, "div", 16);
        ɵɵelementStart(118, "div", 17);
        ɵɵelementStart(119, "div", 18);
        ɵɵelement(120, "label", 48);
        ɵɵelementStart(121, "input", 49);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_121_listener($event) { return ctx.item.userAddressInfo.billingAddress = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(122, RegisterComponent_label_122_Template, 1, 1, "label", 21);
        ɵɵtemplate(123, RegisterComponent_label_123_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(124, "div", 7);
        ɵɵelementStart(125, "div", 18);
        ɵɵelement(126, "label", 46);
        ɵɵelementStart(127, "lib-cddropdown", 50);
        ɵɵlistener("modelkeyChange", function RegisterComponent_Template_lib_cddropdown_modelkeyChange_127_listener($event) { return ctx.item.userAddressInfo.billingCountryId = $event; })("modelvalueChange", function RegisterComponent_Template_lib_cddropdown_modelvalueChange_127_listener($event) { return ctx.billingCounry = $event; })("change", function RegisterComponent_Template_lib_cddropdown_change_127_listener($event) { return ctx.billingCountryChange($event); });
        ɵɵelementEnd();
        ɵɵtemplate(128, RegisterComponent_label_128_Template, 1, 1, "label", 21);
        ɵɵtemplate(129, RegisterComponent_label_129_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(130, "div", 7);
        ɵɵelementStart(131, "div", 18);
        ɵɵelement(132, "label", 51);
        ɵɵelementStart(133, "lib-cddropdown", 52);
        ɵɵlistener("modelkeyChange", function RegisterComponent_Template_lib_cddropdown_modelkeyChange_133_listener($event) { return ctx.item.userAddressInfo.billingStateId = $event; })("change", function RegisterComponent_Template_lib_cddropdown_change_133_listener($event) { return ctx.billingStateChange($event); });
        ɵɵelementEnd();
        ɵɵtemplate(134, RegisterComponent_label_134_Template, 1, 1, "label", 21);
        ɵɵtemplate(135, RegisterComponent_label_135_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(136, "div", 7);
        ɵɵelementStart(137, "div", 18);
        ɵɵelement(138, "label", 53);
        ɵɵelementStart(139, "lib-cddropdown", 52);
        ɵɵlistener("modelkeyChange", function RegisterComponent_Template_lib_cddropdown_modelkeyChange_139_listener($event) { return ctx.item.userAddressInfo.billingCityId = $event; })("change", function RegisterComponent_Template_lib_cddropdown_change_139_listener($event) { return ctx.billingCityChange($event); });
        ɵɵelementEnd();
        ɵɵtemplate(140, RegisterComponent_label_140_Template, 1, 1, "label", 21);
        ɵɵtemplate(141, RegisterComponent_label_141_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(142, "div", 7);
        ɵɵelementStart(143, "div", 18);
        ɵɵelement(144, "label", 54);
        ɵɵelementStart(145, "input", 55);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_145_listener($event) { return ctx.item.userAddressInfo.billingZipCode = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(146, RegisterComponent_label_146_Template, 1, 1, "label", 21);
        ɵɵtemplate(147, RegisterComponent_label_147_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(148, "hr");
        ɵɵelementStart(149, "h5");
        ɵɵelement(150, "span", 15);
        ɵɵelementEnd();
        ɵɵelementStart(151, "div", 16);
        ɵɵelementStart(152, "div", 17);
        ɵɵelementStart(153, "div", 18);
        ɵɵelement(154, "label", 56);
        ɵɵelementStart(155, "input", 57);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_155_listener($event) { return ctx.item.userAddressInfo.shippingAddress = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(156, RegisterComponent_label_156_Template, 1, 1, "label", 21);
        ɵɵtemplate(157, RegisterComponent_label_157_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(158, "div", 7);
        ɵɵelementStart(159, "div", 18);
        ɵɵelement(160, "label", 46);
        ɵɵelementStart(161, "lib-cddropdown", 50);
        ɵɵlistener("modelkeyChange", function RegisterComponent_Template_lib_cddropdown_modelkeyChange_161_listener($event) { return ctx.item.userAddressInfo.shippingCountryId = $event; })("modelvalueChange", function RegisterComponent_Template_lib_cddropdown_modelvalueChange_161_listener($event) { return ctx.shippingCounry = $event; })("change", function RegisterComponent_Template_lib_cddropdown_change_161_listener($event) { return ctx.shippingCountryChange($event); });
        ɵɵelementEnd();
        ɵɵtemplate(162, RegisterComponent_label_162_Template, 1, 1, "label", 21);
        ɵɵtemplate(163, RegisterComponent_label_163_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(164, "div", 7);
        ɵɵelementStart(165, "div", 18);
        ɵɵelement(166, "label", 58);
        ɵɵelementStart(167, "lib-cddropdown", 52);
        ɵɵlistener("modelkeyChange", function RegisterComponent_Template_lib_cddropdown_modelkeyChange_167_listener($event) { return ctx.item.userAddressInfo.shippingStateId = $event; })("change", function RegisterComponent_Template_lib_cddropdown_change_167_listener($event) { return ctx.shippingStateChange($event); });
        ɵɵelementEnd();
        ɵɵtemplate(168, RegisterComponent_label_168_Template, 1, 1, "label", 21);
        ɵɵtemplate(169, RegisterComponent_label_169_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(170, "div", 7);
        ɵɵelementStart(171, "div", 18);
        ɵɵelement(172, "label", 59);
        ɵɵelementStart(173, "lib-cddropdown", 52);
        ɵɵlistener("modelkeyChange", function RegisterComponent_Template_lib_cddropdown_modelkeyChange_173_listener($event) { return ctx.item.userAddressInfo.shippingCityId = $event; })("change", function RegisterComponent_Template_lib_cddropdown_change_173_listener($event) { return ctx.shippingCityChange($event); });
        ɵɵelementEnd();
        ɵɵtemplate(174, RegisterComponent_label_174_Template, 1, 1, "label", 21);
        ɵɵtemplate(175, RegisterComponent_label_175_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(176, "div", 7);
        ɵɵelementStart(177, "div", 18);
        ɵɵelement(178, "label", 60);
        ɵɵelementStart(179, "input", 61);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_179_listener($event) { return ctx.item.userAddressInfo.shippingZipCode = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(180, RegisterComponent_label_180_Template, 1, 1, "label", 21);
        ɵɵtemplate(181, RegisterComponent_label_181_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(182, "hr");
        ɵɵelementStart(183, "h5");
        ɵɵelement(184, "span", 15);
        ɵɵelementEnd();
        ɵɵelementStart(185, "div", 16);
        ɵɵelementStart(186, "div", 7);
        ɵɵelementStart(187, "div", 18);
        ɵɵelement(188, "label", 62);
        ɵɵelementStart(189, "input", 63);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_189_listener($event) { return ctx.item.userAccountInfo.gstNo = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(190, RegisterComponent_label_190_Template, 1, 1, "label", 21);
        ɵɵtemplate(191, RegisterComponent_label_191_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(192, "div", 7);
        ɵɵelementStart(193, "div", 18);
        ɵɵelement(194, "label", 64);
        ɵɵelementStart(195, "input", 65);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_195_listener($event) { return ctx.item.userAccountInfo.coBuyerName = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(196, RegisterComponent_label_196_Template, 1, 1, "label", 21);
        ɵɵtemplate(197, RegisterComponent_label_197_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(198, "div", 17);
        ɵɵelementStart(199, "div", 18);
        ɵɵelement(200, "label", 66);
        ɵɵelementStart(201, "lib-cdmulitselect", 67);
        ɵɵlistener("change", function RegisterComponent_Template_lib_cdmulitselect_change_201_listener($event) { return ctx.sellerChange($event); });
        ɵɵelementEnd();
        ɵɵtemplate(202, RegisterComponent_label_202_Template, 1, 1, "label", 21);
        ɵɵtemplate(203, RegisterComponent_label_203_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(204, "hr");
        ɵɵelementStart(205, "h5");
        ɵɵelement(206, "span", 15);
        ɵɵelementEnd();
        ɵɵelementStart(207, "div", 16);
        ɵɵelementStart(208, "div", 7);
        ɵɵelementStart(209, "div", 18);
        ɵɵelement(210, "label", 68);
        ɵɵelementStart(211, "input", 69);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_211_listener($event) { return ctx.item.userReferralInfo[0].refName = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(212, RegisterComponent_label_212_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(213, "div", 7);
        ɵɵelement(214, "label", 70);
        ɵɵelementStart(215, "input", 71);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_215_listener($event) { return ctx.item.userReferralInfo[0].companyName = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(216, RegisterComponent_label_216_Template, 1, 1, "label", 21);
        ɵɵtemplate(217, RegisterComponent_label_217_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementStart(218, "div", 7);
        ɵɵelementStart(219, "div", 72);
        ɵɵelement(220, "label", 73);
        ɵɵelementStart(221, "input", 74);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_221_listener($event) { return ctx.item.userReferralInfo[0].contactNo = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(222, RegisterComponent_label_222_Template, 1, 1, "label", 21);
        ɵɵtemplate(223, RegisterComponent_label_223_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(224, "div", 7);
        ɵɵelementStart(225, "div", 72);
        ɵɵelement(226, "label", 75);
        ɵɵelementStart(227, "input", 76);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_227_listener($event) { return ctx.item.userReferralInfo[1].refName = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(228, RegisterComponent_label_228_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(229, "div", 7);
        ɵɵelementStart(230, "div", 72);
        ɵɵelement(231, "label", 77);
        ɵɵelementStart(232, "input", 78);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_232_listener($event) { return ctx.item.userReferralInfo[1].companyName = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(233, RegisterComponent_label_233_Template, 1, 1, "label", 21);
        ɵɵtemplate(234, RegisterComponent_label_234_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(235, "div", 7);
        ɵɵelementStart(236, "div", 72);
        ɵɵelement(237, "label", 79);
        ɵɵelementStart(238, "input", 80);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_238_listener($event) { return ctx.item.userReferralInfo[1].contactNo = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(239, RegisterComponent_label_239_Template, 1, 1, "label", 21);
        ɵɵtemplate(240, RegisterComponent_label_240_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(241, "hr");
        ɵɵelementStart(242, "div", 16);
        ɵɵelementStart(243, "div", 17);
        ɵɵelementStart(244, "div", 18);
        ɵɵelement(245, "label", 81);
        ɵɵelement(246, "img", 82);
        ɵɵelementStart(247, "div", 83);
        ɵɵelementStart(248, "div", 84);
        ɵɵelementStart(249, "button", 85);
        ɵɵlistener("click", function RegisterComponent_Template_button_click_249_listener() { return ctx.refreshCaptch(); });
        ɵɵtext(250, "Refresh");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(251, "input", 86);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_251_listener($event) { return ctx.item.captchCode = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(252, RegisterComponent_label_252_Template, 1, 1, "label", 21);
        ɵɵtemplate(253, RegisterComponent_label_253_Template, 2, 1, "label", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(254, "div", 16);
        ɵɵelementStart(255, "div", 17);
        ɵɵelementStart(256, "div", 9);
        ɵɵelementStart(257, "button", 6);
        ɵɵtext(258, "Sign IN");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(259, "div", 87);
        ɵɵelementStart(260, "div", 88);
        ɵɵelementStart(261, "div", 89);
        ɵɵelementStart(262, "div", 90);
        ɵɵelementStart(263, "div", 91);
        ɵɵelementStart(264, "div", 92);
        ɵɵelement(265, "img", 93);
        ɵɵelementStart(266, "p", 94);
        ɵɵtext(267);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(268, "h4", 95);
        ɵɵtext(269, "register Diamonds Beyond Imagination");
        ɵɵelementEnd();
        ɵɵelementStart(270, "div", 96);
        ɵɵelementStart(271, "a", 97);
        ɵɵtext(272, "Visit Website");
        ɵɵelementEnd();
        ɵɵelementStart(273, "a", 98);
        ɵɵtext(274, "LOG IN");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("formGroup", ctx.formgroup);
        ɵɵadvance(4);
        ɵɵproperty("translate", "auth.register.signup");
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.title");
        ɵɵadvance(5);
        ɵɵtextInterpolate1(" ", ctx.Language.toUpperCase(), " ");
        ɵɵadvance(10);
        ɵɵproperty("translate", "auth.register.basicInfo");
        ɵɵadvance(5);
        ɵɵproperty("translate", "auth.register.username");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userName);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("userName").errors == null ? null : ctx.formgroup.get("userName").errors.required) && (ctx.formgroup.get("userName").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("userName").errors == null ? null : ctx.formgroup.get("userName").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.password");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.password);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.required) && (ctx.formgroup.get("password").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "guest.register.confirmPassword");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.confirmPassword);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.required) && (ctx.formgroup.get("confirmPassword").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !(ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.required) && ctx.item.password != ctx.item.confirmPassword && ctx.formgroup.get("confirmPassword").touched);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.company");
        ɵɵadvance(1);
        ɵɵproperty("form", ctx.formgroup)("modelkey", ctx.item.userBasicInfo.companyId)("modelvalue", ctx.companyName)("formcontrolname", "companyId")("path", "GetCompanies")("valuemember", "companyId")("displaymember", "companyName");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("companyId").errors == null ? null : ctx.formgroup.get("companyId").errors.required) && (ctx.formgroup.get("companyId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("companyId").errors == null ? null : ctx.formgroup.get("companyId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.firstName");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.firstName);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("firstName").errors == null ? null : ctx.formgroup.get("firstName").errors.required) && (ctx.formgroup.get("firstName").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("firstName").errors == null ? null : ctx.formgroup.get("firstName").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.lastName");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.lastName);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("lastName").errors == null ? null : ctx.formgroup.get("lastName").errors.required) && (ctx.formgroup.get("lastName").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("lastName").errors == null ? null : ctx.formgroup.get("lastName").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.emailId");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.emailId);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("emailId").errors == null ? null : ctx.formgroup.get("emailId").errors.required) && (ctx.formgroup.get("emailId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("emailId").errors == null ? null : ctx.formgroup.get("emailId").errors.email) && (ctx.formgroup.get("emailId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("emailId").errors == null ? null : ctx.formgroup.get("emailId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.cCEmailId");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.cCEmailId);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("cCEmailId").errors == null ? null : ctx.formgroup.get("cCEmailId").errors.required) && (ctx.formgroup.get("cCEmailId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("cCEmailId").errors == null ? null : ctx.formgroup.get("cCEmailId").errors.email) && (ctx.formgroup.get("cCEmailId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("cCEmailId").errors == null ? null : ctx.formgroup.get("cCEmailId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.contactNo");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.contactNo);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("contactNo").errors == null ? null : ctx.formgroup.get("contactNo").errors.required) && (ctx.formgroup.get("contactNo").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("contactNo").errors == null ? null : ctx.formgroup.get("contactNo").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.faxNo");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.faxNo);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("faxNo").errors == null ? null : ctx.formgroup.get("faxNo").errors.required) && (ctx.formgroup.get("faxNo").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("faxNo").errors == null ? null : ctx.formgroup.get("faxNo").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.whatsAppNo");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.whatsAppNo);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("whatsAppNo").errors == null ? null : ctx.formgroup.get("whatsAppNo").errors.required) && (ctx.formgroup.get("whatsAppNo").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("whatsAppNo").errors == null ? null : ctx.formgroup.get("whatsAppNo").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.skypeId");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.skypeId);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("skypeId").errors == null ? null : ctx.formgroup.get("skypeId").errors.required) && (ctx.formgroup.get("skypeId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("skypeId").errors == null ? null : ctx.formgroup.get("skypeId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.qQId");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.qQId);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("qQId").errors == null ? null : ctx.formgroup.get("qQId").errors.required) && (ctx.formgroup.get("qQId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("qQId").errors == null ? null : ctx.formgroup.get("qQId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.website");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userBasicInfo.website);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("website").errors == null ? null : ctx.formgroup.get("website").errors.required) && (ctx.formgroup.get("website").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("website").errors == null ? null : ctx.formgroup.get("website").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.billingAddresstitle");
        ɵɵadvance(4);
        ɵɵproperty("translate", "auth.register.billingAddress");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userAddressInfo.billingAddress);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("billingAddress").errors == null ? null : ctx.formgroup.get("billingAddress").errors.required) && (ctx.formgroup.get("billingAddress").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("billingAddress").errors == null ? null : ctx.formgroup.get("billingAddress").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.billingCountry");
        ɵɵadvance(1);
        ɵɵproperty("modelkey", ctx.item.userAddressInfo.billingCountryId)("modelvalue", ctx.billingCounry)("form", ctx.formgroup)("formcontrolname", "billingCountryId")("path", "GetCountry")("valuemember", "id")("displaymember", "name");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("billingCountryId").errors == null ? null : ctx.formgroup.get("billingCountryId").errors.required) && (ctx.formgroup.get("billingCountryId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("billingCountryId").errors == null ? null : ctx.formgroup.get("billingCountryId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.billingStateId");
        ɵɵadvance(1);
        ɵɵproperty("params", ctx.billingStateParam)("modelkey", ctx.item.userAddressInfo.billingStateId)("form", ctx.formgroup)("formcontrolname", "billingStateId")("path", "GetStates")("valuemember", "id")("displaymember", "name");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("billingStateId").errors == null ? null : ctx.formgroup.get("billingStateId").errors.required) && (ctx.formgroup.get("billingStateId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("billingStateId").errors == null ? null : ctx.formgroup.get("billingStateId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.billingCityId");
        ɵɵadvance(1);
        ɵɵproperty("params", ctx.billingCityParam)("modelkey", ctx.item.userAddressInfo.billingCityId)("form", ctx.formgroup)("formcontrolname", "billingCityId")("path", "GetCities")("valuemember", "id")("displaymember", "name");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("billingCityId").errors == null ? null : ctx.formgroup.get("billingCityId").errors.required) && (ctx.formgroup.get("billingCityId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("billingCityId").errors == null ? null : ctx.formgroup.get("billingCityId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.billingZipCode");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userAddressInfo.billingZipCode);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("billingZipCode").errors == null ? null : ctx.formgroup.get("billingZipCode").errors.required) && (ctx.formgroup.get("billingZipCode").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("billingZipCode").errors == null ? null : ctx.formgroup.get("billingZipCode").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.shippingAddresstitle");
        ɵɵadvance(4);
        ɵɵproperty("translate", "auth.register.shippingAddress");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userAddressInfo.shippingAddress);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("shippingAddress").errors == null ? null : ctx.formgroup.get("shippingAddress").errors.required) && (ctx.formgroup.get("shippingAddress").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("shippingAddress").errors == null ? null : ctx.formgroup.get("shippingAddress").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.shippingCountry");
        ɵɵadvance(1);
        ɵɵproperty("modelkey", ctx.item.userAddressInfo.shippingCountryId)("modelvalue", ctx.shippingCounry)("form", ctx.formgroup)("formcontrolname", "shippingCountryId")("path", "GetCountry")("valuemember", "id")("displaymember", "name");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("shippingCountryId").errors == null ? null : ctx.formgroup.get("shippingCountryId").errors.required) && (ctx.formgroup.get("shippingCountryId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("shippingCountryId").errors == null ? null : ctx.formgroup.get("shippingCountryId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.shippingStateId");
        ɵɵadvance(1);
        ɵɵproperty("params", ctx.shippingStateParam)("modelkey", ctx.item.userAddressInfo.shippingStateId)("form", ctx.formgroup)("formcontrolname", "shippingStateId")("path", "GetStates")("valuemember", "id")("displaymember", "name");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("shippingStateId").errors == null ? null : ctx.formgroup.get("shippingStateId").errors.required) && (ctx.formgroup.get("shippingStateId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("shippingStateId").errors == null ? null : ctx.formgroup.get("shippingStateId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.shippingCityId");
        ɵɵadvance(1);
        ɵɵproperty("params", ctx.shippingCityParam)("modelkey", ctx.item.userAddressInfo.shippingCityId)("form", ctx.formgroup)("formcontrolname", "shippingCityId")("path", "GetCities")("valuemember", "id")("displaymember", "name");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("shippingCityId").errors == null ? null : ctx.formgroup.get("shippingCityId").errors.required) && (ctx.formgroup.get("shippingCityId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("shippingCityId").errors == null ? null : ctx.formgroup.get("shippingCityId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.shippingZipCode");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userAddressInfo.shippingZipCode);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("shippingZipCode").errors == null ? null : ctx.formgroup.get("shippingZipCode").errors.required) && (ctx.formgroup.get("shippingZipCode").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("shippingZipCode").errors == null ? null : ctx.formgroup.get("shippingZipCode").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.accountTitle");
        ɵɵadvance(4);
        ɵɵproperty("translate", "auth.register.gstNo");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userAccountInfo.gstNo);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("gstNo").touched || ctx.submited) && (ctx.item.userAccountInfo.gstNo == "" || ctx.item.userAccountInfo.gstNo == undefined) && ((ctx.billingCounry == undefined ? "" : ctx.billingCounry).toUpperCase() == "INDIA" || (ctx.shippingCounry == undefined ? "" : ctx.shippingCounry).toUpperCase() == "INDIA"));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("gstNo").errors == null ? null : ctx.formgroup.get("gstNo").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.coBuyerName");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userAccountInfo.coBuyerName);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("coBuyerName").errors == null ? null : ctx.formgroup.get("coBuyerName").errors.required) && (ctx.formgroup.get("coBuyerName").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("coBuyerName").errors == null ? null : ctx.formgroup.get("coBuyerName").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.sellerId");
        ɵɵadvance(1);
        ɵɵproperty("modelkey", ctx.item.sellerId)("datasource", ctx.sellerList)("form", ctx.formgroup)("formcontrolname", "sellerId")("valuemember", "id")("displaymember", "userName");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("sellerId").errors == null ? null : ctx.formgroup.get("sellerId").errors.required) && (ctx.formgroup.get("sellerId").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("sellerId").errors == null ? null : ctx.formgroup.get("sellerId").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.referralTitle");
        ɵɵadvance(4);
        ɵɵproperty("translate", "auth.register.refName");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userReferralInfo[0].refName);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("refName1").errors == null ? null : ctx.formgroup.get("refName1").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "auth.register.refCompany");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userReferralInfo[0].companyName);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.item.userReferralInfo[0].refName != "" && ctx.item.userReferralInfo[0].refName != undefined && (ctx.item.userReferralInfo[0].companyName == "" || ctx.item.userReferralInfo[0].companyName == undefined) && (ctx.formgroup.get("refcompanyName1").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("refcompanyName1").errors == null ? null : ctx.formgroup.get("refcompanyName1").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.refcontactNo");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userReferralInfo[0].contactNo);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.item.userReferralInfo[0].refName != "" && ctx.item.userReferralInfo[0].refName != undefined && (ctx.item.userReferralInfo[0].companyName == "" || ctx.item.userReferralInfo[0].companyName == undefined) && (ctx.formgroup.get("refcontactNo1").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("refcontactNo1").errors == null ? null : ctx.formgroup.get("refcontactNo1").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.refName");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userReferralInfo[1].refName);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("refName2").errors == null ? null : ctx.formgroup.get("refName2").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.refCompany");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userReferralInfo[1].companyName);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.item.userReferralInfo[1].refName != "" && ctx.item.userReferralInfo[1].refName != undefined && (ctx.item.userReferralInfo[1].companyName == "" || ctx.item.userReferralInfo[1].companyName == undefined) && (ctx.formgroup.get("refcompanyName2").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("refcompanyName2").errors == null ? null : ctx.formgroup.get("refcompanyName2").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.register.refcontactNo");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.userReferralInfo[1].contactNo);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.item.userReferralInfo[1].refName != "" && ctx.item.userReferralInfo[1].refName != undefined && (ctx.item.userReferralInfo[1].companyName == "" || ctx.item.userReferralInfo[1].companyName == undefined) && (ctx.formgroup.get("refcontactNo2").touched || ctx.submited));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("refcontactNo2").errors == null ? null : ctx.formgroup.get("refcontactNo2").errors.serverError);
        ɵɵadvance(5);
        ɵɵproperty("translate", "auth.register.captchCode");
        ɵɵadvance(1);
        ɵɵproperty("src", ctx.captchaImg, ɵɵsanitizeUrl);
        ɵɵadvance(5);
        ɵɵproperty("ngModel", ctx.item.captchCode);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("captchCode").errors == null ? null : ctx.formgroup.get("captchCode").errors.required) && (ctx.submited || ctx.formgroup.get("captchCode").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("captchCode").errors == null ? null : ctx.formgroup.get("captchCode").errors.serverError);
        ɵɵadvance(4);
        ɵɵproperty("translate", "auth.register.signup");
        ɵɵadvance(8);
        ɵɵproperty("src", ctx.AppLogo, ɵɵsanitizeUrl);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.AppTitle);
        ɵɵadvance(4);
        ɵɵproperty("translate", "index.visitwebsite");
        ɵɵadvance(2);
        ɵɵproperty("translate", "index.login");
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, TranslateDirective, DefaultValueAccessor, MaxLengthValidator, NgControlStatus, FormControlName, NgIf, CDDropdownComponent, CdmulitselectComponent], styles: ["form[_ngcontent-%COMP%]{width:100%!important;max-width:none!important;padding:20px!important}legend[_ngcontent-%COMP%]{color:#fff}.landing-main[_ngcontent-%COMP%]{background-image:linear-gradient(#23599e,#1a2b4a)!important}.img-fluid[_ngcontent-%COMP%]{width:420px!important}.col-sm-12[_ngcontent-%COMP%], .col-sm-6[_ngcontent-%COMP%]{padding-right:22px!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RegisterComponent, [{
        type: Component,
        args: [{
                selector: 'lib-register',
                templateUrl: './register.component.html',
                styleUrls: ['./register.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }, { type: TranslateService }, { type: FormValidationService }, { type: loaderserice }, { type: Router }, { type: loginService }, { type: alertserice }, { type: NgZone }]; }, null); })();

class ResetPasswordModel {
}

function ResetPasswordComponent_label_22_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 26);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.reset.password_error");
} }
function ResetPasswordComponent_label_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 27);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r1.translate.instant(ctx_r1.formgroup.get("password").errors == null ? null : ctx_r1.formgroup.get("password").errors.serverError), " ");
} }
function ResetPasswordComponent_label_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 26);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.reset.confirmPassword_error");
} }
function ResetPasswordComponent_label_28_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 26);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.reset.confirmPassword_matche_error");
} }
function ResetPasswordComponent_label_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 27);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r4.translate.instant(ctx_r4.formgroup.get("confirmPassword").errors == null ? null : ctx_r4.formgroup.get("confirmPassword").errors.serverError), " ");
} }
function ResetPasswordComponent_label_38_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 26);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.reset.captchCode_error");
} }
function ResetPasswordComponent_label_39_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 27);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r6.translate.instant(ctx_r6.formgroup.get("captchCode").errors == null ? null : ctx_r6.formgroup.get("captchCode").errors.serverError), " ");
} }
class ResetPasswordComponent {
    constructor(environment, loginservice, translate, formvalidationService, loader, router, alertService, route) {
        this.environment = environment;
        this.loginservice = loginservice;
        this.translate = translate;
        this.formvalidationService = formvalidationService;
        this.loader = loader;
        this.router = router;
        this.alertService = alertService;
        this.route = route;
        this.submited = false;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
        translate.translations;
    }
    ngOnInit() {
        this.item = new ResetPasswordModel();
        this.route
            .queryParams
            .subscribe(params => {
            try {
                let UserId = params.UserId;
                this.item.id = UserId;
                if (UserId == undefined) {
                    return;
                }
            }
            catch (error) {
                // this._alertserice.Error("Notification", error); this.loader.show(false);
            }
        });
        this.formgroup = new FormGroup({
            password: new FormControl('', Validators.required),
            confirmPassword: new FormControl('', Validators.compose([Validators.required])),
            captchCode: new FormControl('', Validators.required)
        });
        this.refreshCaptch();
    }
    submit() {
        this.submited = true;
        if (this.formgroup.valid) {
            this.loader.show(true);
            this.loginservice.ResetPassword(this.item).subscribe(result => {
                this.loader.show(false);
                if (result.status) {
                    this.alertService.success('Success', this.translate.instant(result.message));
                    this.formgroup.reset();
                }
                else {
                    this.alertService.Error('Error', this.translate.instant(result.message));
                }
            }, reject => {
                this.loader.show(false);
                this.alertService.Error('Error', this.translate.instant('auth.reset.error'));
                try {
                    this.formvalidationService.BindServerErrors(this.formgroup, reject.error);
                }
                catch (error) {
                    console.log(error);
                }
            });
        }
    }
    refreshCaptch() {
        this.loginservice.getCaptch().subscribe(result => {
            this.captchaImg = result.imgpath;
        });
    }
}
ResetPasswordComponent.ɵfac = function ResetPasswordComponent_Factory(t) { return new (t || ResetPasswordComponent)(ɵɵdirectiveInject(EnvironmentService), ɵɵdirectiveInject(loginService), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(FormValidationService), ɵɵdirectiveInject(loaderserice), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(alertserice), ɵɵdirectiveInject(ActivatedRoute)); };
ResetPasswordComponent.ɵcmp = ɵɵdefineComponent({ type: ResetPasswordComponent, selectors: [["lib-reset-password"]], decls: 44, vars: 19, consts: [[1, "overlay"], [1, "signin", "d-flex"], [1, "container"], [1, "row"], [1, "col"], [1, "d-flex", "justify-content-between", "signin-header", "align-items-center"], [1, "logo"], ["href", "#"], ["alt", "", "width", "143px", 1, "img-fluid", 3, "src"], ["routerLink", "/auth/login", 1, "login-btn"], [1, "signin-form", 3, "formGroup", "ngSubmit"], [3, "translate"], [1, "form-group", "m-0"], ["for", "password m-0", 3, "translate"], ["formControlName", "password", "name", "password", "type", "password", "id", "password", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["class", "form-text text-danger", 3, "translate", 4, "ngIf"], ["class", "form-text text-danger", 4, "ngIf"], ["formControlName", "confirmPassword", "name", "confirmPassword", "type", "password", "id", "confirmPassword", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "captchCode m-0", 3, "translate"], [2, "margin-left", "5px", 3, "src"], [1, "input-group"], [1, "input-group-prepend"], ["type", "button", "id", "button-addon1", "wfd-id", "1448", 1, "btn", "btn-outline-secondary", 3, "click"], ["formControlName", "captchCode", "name", "captchCode", "type", "text", "id", "captchCode", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "d-flex", "justify-content-between", "signin-btn"], ["type", "submit", 1, "signin-btn", 3, "translate"], [1, "form-text", "text-danger", 3, "translate"], [1, "form-text", "text-danger"]], template: function ResetPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "section", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelementStart(6, "div", 6);
        ɵɵelementStart(7, "a", 7);
        ɵɵelement(8, "img", 8);
        ɵɵelementStart(9, "p");
        ɵɵelementStart(10, "small");
        ɵɵtext(11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "a", 9);
        ɵɵtext(13, "Login");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 3);
        ɵɵelementStart(15, "div", 4);
        ɵɵelementStart(16, "form", 10);
        ɵɵlistener("ngSubmit", function ResetPasswordComponent_Template_form_ngSubmit_16_listener() { return ctx.submit(); });
        ɵɵelementStart(17, "h4", 11);
        ɵɵtext(18, "RESET password");
        ɵɵelementEnd();
        ɵɵelementStart(19, "div", 12);
        ɵɵelement(20, "label", 13);
        ɵɵelementStart(21, "input", 14);
        ɵɵlistener("ngModelChange", function ResetPasswordComponent_Template_input_ngModelChange_21_listener($event) { return ctx.item.password = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(22, ResetPasswordComponent_label_22_Template, 1, 1, "label", 15);
        ɵɵtemplate(23, ResetPasswordComponent_label_23_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(24, "div", 12);
        ɵɵelement(25, "label", 13);
        ɵɵelementStart(26, "input", 17);
        ɵɵlistener("ngModelChange", function ResetPasswordComponent_Template_input_ngModelChange_26_listener($event) { return ctx.item.confirmPassword = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(27, ResetPasswordComponent_label_27_Template, 1, 1, "label", 15);
        ɵɵtemplate(28, ResetPasswordComponent_label_28_Template, 1, 1, "label", 15);
        ɵɵtemplate(29, ResetPasswordComponent_label_29_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(30, "div", 12);
        ɵɵelement(31, "label", 18);
        ɵɵelement(32, "img", 19);
        ɵɵelementStart(33, "div", 20);
        ɵɵelementStart(34, "div", 21);
        ɵɵelementStart(35, "button", 22);
        ɵɵlistener("click", function ResetPasswordComponent_Template_button_click_35_listener() { return ctx.refreshCaptch(); });
        ɵɵtext(36, "Refresh");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(37, "input", 23);
        ɵɵlistener("ngModelChange", function ResetPasswordComponent_Template_input_ngModelChange_37_listener($event) { return ctx.item.captchCode = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(38, ResetPasswordComponent_label_38_Template, 1, 1, "label", 15);
        ɵɵtemplate(39, ResetPasswordComponent_label_39_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(40, "div", 12);
        ɵɵelementStart(41, "div", 24);
        ɵɵelementStart(42, "button", 25);
        ɵɵtext(43, "Submit");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(8);
        ɵɵproperty("src", ctx.AppLogo, ɵɵsanitizeUrl);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.AppTitle);
        ɵɵadvance(5);
        ɵɵproperty("formGroup", ctx.formgroup);
        ɵɵadvance(1);
        ɵɵproperty("translate", "auth.reset.title");
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.reset.password");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.password);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.required) && (ctx.submited || ctx.formgroup.get("password").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "auth.reset.confirmPassword");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.confirmPassword);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.required) && (ctx.submited || ctx.formgroup.get("confirmPassword").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !(ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.required) && ctx.item.password != ctx.item.confirmPassword && ctx.formgroup.get("confirmPassword").touched);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "auth.reset.captchCode");
        ɵɵadvance(1);
        ɵɵproperty("src", ctx.captchaImg, ɵɵsanitizeUrl);
        ɵɵadvance(5);
        ɵɵproperty("ngModel", ctx.item.captchCode);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("captchCode").errors == null ? null : ctx.formgroup.get("captchCode").errors.required) && (ctx.submited || ctx.formgroup.get("captchCode").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("captchCode").errors == null ? null : ctx.formgroup.get("captchCode").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "auth.reset.signup");
    } }, directives: [RouterLinkWithHref, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, TranslateDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgIf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ResetPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'lib-reset-password',
                templateUrl: './reset-password.component.html',
                styleUrls: ['./reset-password.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }, { type: loginService }, { type: TranslateService }, { type: FormValidationService }, { type: loaderserice }, { type: Router }, { type: alertserice }, { type: ActivatedRoute }]; }, null); })();

const routes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'register',
        component: RegisterComponent
    },
    {
        path: 'ResetPassword',
        component: ResetPasswordComponent
    }
];
class ServiceAccountRoutingModule {
}
ServiceAccountRoutingModule.ɵmod = ɵɵdefineNgModule({ type: ServiceAccountRoutingModule });
ServiceAccountRoutingModule.ɵinj = ɵɵdefineInjector({ factory: function ServiceAccountRoutingModule_Factory(t) { return new (t || ServiceAccountRoutingModule)(); }, imports: [[RouterModule.forChild(routes)],
        RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ServiceAccountRoutingModule, { imports: [RouterModule], exports: [RouterModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceAccountRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule]
            }]
    }], null, null); })();

class ServiceAccountModule {
    static forRoot() {
        return {
            ngModule: ServiceAccountModule,
            providers: [
                loginService
            ]
        };
    }
}
ServiceAccountModule.ɵmod = ɵɵdefineNgModule({ type: ServiceAccountModule });
ServiceAccountModule.ɵinj = ɵɵdefineInjector({ factory: function ServiceAccountModule_Factory(t) { return new (t || ServiceAccountModule)(); }, imports: [[
            ServiceAccountRoutingModule,
            FormsModule, ReactiveFormsModule,
            TranslateModule.forChild(),
            CommonModule,
            ServiceCommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ServiceAccountModule, { declarations: [ServiceAccountComponent, LoginComponent, RegisterComponent, ResetPasswordComponent], imports: [ServiceAccountRoutingModule,
        FormsModule, ReactiveFormsModule, TranslateModule, CommonModule,
        ServiceCommonModule], exports: [ServiceAccountComponent, LoginComponent, RegisterComponent, ResetPasswordComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceAccountModule, [{
        type: NgModule,
        args: [{
                declarations: [ServiceAccountComponent, LoginComponent, RegisterComponent, ResetPasswordComponent],
                imports: [
                    ServiceAccountRoutingModule,
                    FormsModule, ReactiveFormsModule,
                    TranslateModule.forChild(),
                    CommonModule,
                    ServiceCommonModule
                ],
                exports: [ServiceAccountComponent, LoginComponent, RegisterComponent, ResetPasswordComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of service-account
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LoginComponent, RegisterComponent, ResetPasswordComponent, ServiceAccountComponent, ServiceAccountModule, ServiceAccountService, loginService };
//# sourceMappingURL=service-account.js.map
